<div class="question-scores">
  <div class="loading-state" *ngIf="isLoading">
    <i class="fa fa-spinner fa-spin" aria-hidden="true"></i>
    <span translate>WORK_ENVIRONMENT_SURVEY.LOADING</span>
  </div>

  <div class="card question-card" *ngFor="let row of rows">
    <div class="question-card__top">
      <div class="question-card__text">
        <span class="question-card__number">{{ row.Number }}.</span>
        <span>{{ row.Text }}</span>
      </div>

      <div class="question-card__index" *ngIf="benchmarkIndex !== null">
        <span class="index-badge" translate>
          WORK_ENVIRONMENT_SURVEY.INDEX
        </span>
        <span class="index-value">{{ benchmarkIndex }}</span>
      </div>
    </div>

    <div class="question-card__delta" *ngIf="row.Delta !== null">
      <span [class.positive]="row.Delta >= 0" [class.negative]="row.Delta < 0">
        {{ row.Delta > 0 ? "+" : "" }}{{ row.Delta }}
      </span>
    </div>

    <div class="score-bar">
      <div class="score-bar__track">
        <div
          class="score-bar__fill"
          [style.width.%]="row.FillPercent"
          [style.background-color]="row.BarColor"
        >
          <span class="score-bar__value">{{
            row.AverageScore | number: "1.1-1"
          }}</span>
        </div>
      </div>
      <div class="score-bar__scale">
        <span>0</span>
        <span>{{ maxScore }}</span>
      </div>
    </div>
  </div>

  <div class="empty-state" *ngIf="!isLoading && !rows.length">
    <span translate>WORK_ENVIRONMENT_SURVEY.NO_RESULTS</span>
  </div>
</div>
